<form [formGroup]="form" *ngIf="form">
  <se-fe-form-field *ngIf="loaded"
    [seFeDataConfig]="{
      label: seFeDataLabel,
      required: isRequired,
      errorMessages: errorMessages}">
    <se-fe-datepicker class="dob-datepicker"
      [formControlName]="ngControl.name"
      [seFeDataSuffix]="age"
      [seFeDataExcludeDates]="datepickerLimit"
      [seFeDataYearRange]="{ future: 0, past: 100 }"
      seFeDataSuffixSize=3
      [seFeDataComfy]="true">
    </se-fe-datepicker>
    <div seFeHelp *ngIf="control['helpText']">
      {{ control['helpText'] }}
    </div>
  </se-fe-form-field>
</form>
